import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import ru from './locales/ru.json';

export type Locale = 'en' | 'es' | 'de' | 'ru' | 'fr';

export const defaultLocale: Locale = 'en';

export const availableLocales: Locale[] = ['en', 'es', 'de', 'ru', 'fr'];

export const localeLabels: Record<Locale, string> = {
  en: 'English (EN)',
  es: 'Español (ES)',
  de: 'Deutsch (DE)',
  ru: 'Русский (RU)',
  fr: 'Français (FR)',
};

export const translations = {
  en,
  es,
  de,
  ru,
  fr,
};

export function getTranslation(locale: Locale) {
  return translations[locale] || translations[defaultLocale];
}

export type TranslationParams = Record<string, string | number>;

export function t(key: string, locale: Locale = defaultLocale, params?: TranslationParams) {
  const translation = getTranslation(locale);
  const value = key.split('.').reduce<unknown>((obj, k) => {
    if (obj && typeof obj === 'object' && k in obj) {
      return (obj as Record<string, unknown>)[k];
    }
    return undefined;
  }, translation);
  let result = typeof value === 'string' ? value : key;
  if (params) {
    for (const [param, replacement] of Object.entries(params)) {
      result = result.replace(new RegExp(`{{\\s*${param}\\s*}}`, 'g'), String(replacement));
    }
  }
  return result;
}
